(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchetas-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-anchetas-builder]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const formArea = section.querySelector('[data-anchetas-form]');
    const successMessage = section.querySelector('[data-forms-success]');
    const submissionReceived = new URLSearchParams(window.location.search).get('form_success') === '1';
    const appSection = section.closest('.shopify-section')?.nextElementSibling;
    const designTemplate = section.querySelector('[data-forms-design]');

    if (appSection && designTemplate && !appSection.classList.contains('anchetas-builder__forms-section')) {
      const formBlock = appSection.querySelector('.shopify-app-block');
      const design = designTemplate.content.cloneNode(true);
      const formSlot = design.querySelector('[data-forms-slot]');
      appSection.classList.add('anchetas-builder__forms-section');
      appSection.replaceChildren(design);
      if (formBlock && formSlot) formSlot.appendChild(formBlock);

      const applyFormDesign = () => {
        const host = appSection.querySelector('shopify-forms-embed');
        if (!host || !host.shadowRoot || host.shadowRoot.querySelector('[data-anchetas-form-style]')) return false;
        const style = document.createElement('style');
        style.dataset.anchetasFormStyle = 'true';
        style.textContent = `
          :host { --forms-base-font-size: 11px; --forms-body-font: normal 300 11px "Atlantic Helvetica", Helvetica, Arial, sans-serif; --form-text-color: #191919; --form-placeholder-color: #d4bbad; --form-background-color: #f1e5d4; --button-text-color: #efe5d6; --button-background-color: #b6945b; --button-border-radius: 0px; --input-border-radius: 0px; }
          :host, :host > div, :host > div > div { display: block !important; box-sizing: border-box !important; width: 100% !important; max-width: none !important; }
          [role="dialog"], [role="dialog"] > div { box-sizing: border-box !important; width: 100% !important; }
          [role="dialog"] { display: block !important; max-width: none !important; padding: 0 !important; background: transparent !important; }
          [role="dialog"] > div:first-child, section[class*="formHeader"], div[class*="formDisclaimer"] { display: none !important; }
          form { box-sizing: border-box !important; display: grid !important; width: 100% !important; max-width: none !important; grid-template-columns: repeat(3, minmax(0, 1fr)); column-gap: 12px !important; row-gap: 20px !important; margin: 0 !important; padding: 0 !important; }
          form > div, form > button { min-width: 0; margin: 0 !important; }
          form > [data-anchetas-field="name"] { grid-column: 1; grid-row: 1; order: 1; }
          form > [data-anchetas-field="role"] { grid-column: 2; grid-row: 1; order: 2; }
          form > [data-anchetas-field="company"] { grid-column: 3; grid-row: 1; order: 3; }
          form > [data-anchetas-field="email"] { grid-column: 1; grid-row: 2; order: 4; }
          form > [data-anchetas-field="phone"] { grid-column: 2; grid-row: 2; order: 5; }
          form > [data-anchetas-field="employees"] { grid-column: 3; grid-row: 2; order: 6; }
          form > [data-anchetas-field="city"] { grid-column: 1; grid-row: 3; order: 7; }
          form > [data-anchetas-field="quantity"] { grid-column: 2; grid-row: 3; order: 8; }
          form > [data-anchetas-field="system"], form > div:has(shop-lead-capture) { position: absolute !important; width: 0 !important; height: 0 !important; overflow: hidden !important; }
          form > [data-anchetas-field]:not([data-anchetas-field="system"]) { box-sizing: border-box !important; display: grid !important; grid-template-columns: minmax(0, 1fr) !important; grid-template-rows: auto 38px !important; gap: 2px !important; height: 54px !important; min-height: 54px !important; }
          form > [data-anchetas-field="phone"] { position: relative !important; display: block !important; height: 54px !important; padding-top: 16px !important; }
          form > [data-anchetas-field="phone"] > div:last-child { position: static !important; display: block !important; height: 38px !important; }
          form > [data-anchetas-field="phone"] .phone-country-selector { display: none !important; }
          form > [data-anchetas-field="phone"] label { position: absolute !important; top: 0 !important; left: 0 !important; }
          input, form > div > button { box-sizing: border-box !important; width: 100% !important; height: 38px !important; min-height: 38px !important; border: 0 !important; border-radius: 0 !important; padding: 0 8px !important; background: #f1e5d4 !important; color: #191919 !important; box-shadow: none !important; font-family: "Atlantic Helvetica", Helvetica, Arial, sans-serif !important; font-size: 12px !important; font-weight: 300 !important; line-height: 1 !important; }
          input::placeholder { color: #d4bbad !important; opacity: 1 !important; text-transform: uppercase !important; }
          label, p[id$="selector-label"] { position: static !important; inset: auto !important; order: -1 !important; margin: 0 !important; padding: 0 !important; color: #d0bcb0 !important; font-family: "Atlantic Helvetica", Helvetica, Arial, sans-serif !important; font-size: 14px !important; font-weight: 300 !important; line-height: 1 !important; transform: none !important; text-transform: uppercase !important; }
          form > [data-anchetas-field="phone"] input[data-anchetas-phone-real] { position: absolute !important; width: 1px !important; height: 1px !important; min-height: 0 !important; padding: 0 !important; opacity: 0 !important; pointer-events: none !important; }
          form > button { box-sizing: border-box !important; display: flex !important; grid-column: 3; grid-row: 3; order: 9 !important; width: 100% !important; height: 54px !important; min-height: 54px !important; align-items: center !important; justify-content: center !important; padding: 0 14px !important; border: 0 !important; border-radius: 0 !important; background: #b6945b !important; color: #efe5d6 !important; font-family: "Atlantic Helvetica", Helvetica, Arial, sans-serif !important; font-size: 18px !important; font-weight: 300 !important; line-height: 1 !important; text-align: center !important; text-transform: uppercase !important; }
          @media (max-width: 989px) {
            form { grid-template-columns: repeat(2, minmax(0, 1fr)); }
            form > [data-anchetas-field]:not([data-anchetas-field="system"]), form > button { grid-column: auto; grid-row: auto; }
          }
          @media (max-width: 599px) { form { grid-template-columns: 1fr; } }
        `;
        host.shadowRoot.appendChild(style);

        const form = host.shadowRoot.querySelector('form');
        const fieldNames = {
          'nombre': 'name',
          'cargo': 'role',
          'empresa': 'company',
          'correo electronico': 'email',
          'telefono': 'phone',
          'numero de empleados': 'employees',
          'ciudad': 'city',
          'cantidad de anchetas': 'quantity'
        };

        form?.querySelectorAll(':scope > div').forEach((field) => {
          if (field.querySelector('shop-lead-capture')) {
            field.dataset.anchetasField = 'system';
            return;
          }
          const label = field.textContent
            .trim()
            .toLocaleLowerCase('es')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ');
          if (fieldNames[label]) field.dataset.anchetasField = fieldNames[label];

          const input = field.querySelector('input');
          if (input && fieldNames[label]) input.placeholder = field.textContent.trim().toLocaleUpperCase('es');

          if (fieldNames[label] === 'employees') {
            const employeeLabel = field.querySelector('label');
            if (employeeLabel) employeeLabel.textContent = 'N° EMPLEADOS';
            if (input) input.placeholder = 'N° EMPLEADOS';
          }

          // El teléfono de Shopify Forms es un input controlado que siempre conserva el
          // prefijo "+57 " y descarta cualquier edición delante de él: al enfocarlo el cursor
          // cae en la posición 0 y las teclas se pierden. Mostramos un input propio con solo
          // el número local y le pasamos al real el valor ya prefijado.
          if (fieldNames[label] === 'phone' && input && field.dataset.anchetasPhoneReady !== 'true') {
            field.dataset.anchetasPhoneReady = 'true';
            input.dataset.anchetasPhoneReal = 'true';
            input.tabIndex = -1;
            input.setAttribute('aria-hidden', 'true');

            const localInput = document.createElement('input');
            localInput.type = 'tel';
            localInput.inputMode = 'numeric';
            localInput.autocomplete = 'tel-national';
            localInput.placeholder = input.placeholder;
            localInput.setAttribute('aria-label', 'Teléfono');
            localInput.dataset.anchetasPhoneLocal = 'true';
            localInput.value = input.value.replace(/\D/g, '').replace(/^57/, '');
            input.insertAdjacentElement('afterend', localInput);

            const phoneLabel = field.querySelector('label');
            if (phoneLabel) {
              phoneLabel.removeAttribute('for');
              phoneLabel.addEventListener('click', () => localInput.focus());
            }

            localInput.addEventListener('input', () => {
              const digits = localInput.value.replace(/\D/g, '');
              if (localInput.value !== digits) localInput.value = digits;
              const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
              valueSetter?.call(input, '+57 ' + digits);
              input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
              input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
            });
          }
        });
        return true;
      };

      if (!applyFormDesign()) {
        const designTimer = window.setInterval(() => {
          if (applyFormDesign()) window.clearInterval(designTimer);
        }, 150);
        window.setTimeout(() => window.clearInterval(designTimer), 10000);
      }
    }

    if (submissionReceived && successMessage) {
      successMessage.hidden = false;
      if (appSection) {
        const formBlock = appSection.querySelector('.shopify-app-block');
        const formSlot = appSection.querySelector('[data-forms-slot]');
        if (formBlock) formBlock.hidden = true;
        if (formSlot) formSlot.appendChild(successMessage);
      }
      requestAnimationFrame(() => successMessage.focus({ preventScroll: true }));
    }

    section.querySelectorAll('[data-advisor-cta]').forEach((button) => {
      button.addEventListener('click', () => {
        formArea.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
